import React from 'react';
import { m } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../../utils/checkout';
export function FinalCTA() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-65" data-mp="3mtrzkafbyh2x">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-66" data-mp="3mt8qzkbkl51k">
        <h2 className="font-heading text-3xl font-bold uppercase leading-tight text-azul sm:text-4xl" data-id="element-67" data-mp="3rs38mixswnk3">
          La decisión es tuya.
        </h2>
        <div className="mx-auto mt-6 max-w-2xl space-y-3 text-left text-base leading-relaxed text-muted sm:text-center" data-id="element-68" data-mp="3dv6kwqczbm7f">
          <p data-id="element-69" data-mp="33uw8v92okktu">
            Puedes seguir como hasta ahora. Preparando entrenamientos desde cero cada semana, improvisando
            cuando el plan falla y llegando a la pista con la duda de si lo que vas a hacer es lo correcto
            para tu equipo.
          </p>
          <p data-id="element-70" data-mp="124cb3m3l34gg">
            O puedes llegar al martes con todo listo. Con la sesión elegida, el objetivo claro y la
            corrección exacta en el bolsillo.
          </p>
          <p className="font-semibold text-gris-oscuro" data-id="element-71" data-mp="q7c4uqmra69g">150 sesiones. 6 tomos. 5 bonos. 14 días de garantía.</p>
          <p className="text-naranja" data-id="element-72" data-mp="l90umesjttqp">El precio de una cena. El valor de una temporada entera.</p>
        </div>

        <m.a href={CHECKOUT_URL} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="group mx-auto mt-8 flex max-w-sm flex-col items-center gap-3 rounded-2xl border-2 border-naranja bg-white p-6 text-center shadow-card transition-colors hover:border-naranja/70" data-id="element-73" data-mp="z05qr6wpk3wa">
          <span className="font-heading text-sm font-semibold uppercase tracking-wide text-muted" data-id="element-74" data-mp="g834ng1arven">
            🏐 VOLEY-PRO 360: La Pizarra del Entrenador
          </span>
          <span className="font-heading text-3xl font-bold text-azul" data-id="element-75" data-mp="1ro1kq3uw7hpd">17,99€</span>
          <span className="mt-2 inline-flex items-center gap-2 rounded-xl bg-gradient-to-br from-azul to-azul-dark px-6 py-3 text-sm font-semibold uppercase text-white transition-[filter] group-hover:brightness-90" data-id="element-76" data-mp="1mpq6zi1h8n1v">
            Quiero Voley-Pro 360
            <ArrowRightIcon size={16} className="transition-transform group-hover:translate-x-1" data-id="element-77" data-mp="tds6b6zzoqvr" />
          </span>
          <span className="text-[11px] text-muted" data-id="element-78" data-mp="ycmqoddlunhz">
            💳 Pago único · ⚡ Acceso inmediato · 🛡️ Garantía 14 días
          </span>
        </m.a>
      </div>
    </section>;
}